import { List, ListItem, Stack, Typography } from '@mui/material';

import { StyledList } from './styles';

const Terms = () => {
  return (
    <>
      <Stack
        alignItems={'center'}
        sx={{
          margin: 'auto',
        }}
      >
        <Stack gap={1.5}>
          <Typography alignSelf={'center'} sx={{ fontFamily: 'Verdana, sans-serif', pt: '20px' }}>
            <b>TERMS AND CONDITIONS OF EMPLOYMENT</b>
          </Typography>

          <StyledList>
            <List sx={{ listStyleType: 'none', pl: 2, pt: 0 }}>
              <ListItem>
                <Typography variant="subtitle1">General Terms:</Typography>
                <Typography>
                  You are expected to devote your full business time, attention and energies to the
                  performance of your duties with the Company. Your place of work will be SGNR,
                  Rajasthan, India. Under the terms of this Agreement, and without the need to
                  terminate the employment relationship, the Company may assign you additional tasks
                  or to a new manager, modify or remove your assigned duties, or change the place of
                  your employment without additional compensation to you. You also hereby consent
                  and agree to any amendments to these Terms and Conditions of Employment, as deemed
                  necessary by SyncGlob. You will, in addition to the terms and conditions of
                  employment specifically stated herein, also be governed by the rules, regulations
                  and such other practices, systems, procedures and policies framed, amended,
                  modified or omitted by the Company. You will also be governed by statutory laws
                  enacted by Central or State Government or local authorities as may be applicable
                  to you.
                </Typography>
              </ListItem>

              <ListItem>
                <Typography variant="subtitle1">Compensation:</Typography>
                <Typography>
                  Your annual compensation is in accordance with the Company&apos;s standard payroll
                  practices for salaried employees in India. The compensation will be subject to the
                  usual deductions including deductions for tax and statutory contribution normally
                  to be withheld by an employer in India and will be subject to adjustment pursuant
                  to the Company&apos;s compensation policies in effect and your performance. In
                  case you are assigned to work outside your normal place of posting, the specific
                  deputation letter would notify you of any changes in the compensation and
                  benefits. In the event you are sent abroad on training and / or project work, you
                  may be required to sign an Agreement for service with the company as per the
                  policy of the company.
                </Typography>
              </ListItem>

              {/* <ListItem>
                <Typography variant="subtitle1">Probation:</Typography>
                <Typography>
                  You will be on probation for a period of 6 months from the date of joining. If you
                  have been engaged with the organization as an Intern/Management Trainee, and if
                  that engagement is being converted to a full-time role, probation period will
                  stand reduced to the extent of this engagement.
                </Typography>
              </ListItem> */}

              <ListItem>
                <Typography variant="subtitle1">
                  Notice period & Termination of Employment:
                </Typography>
                <Typography>
                  <b>Termination by the company:</b> The Company may terminate your services with or
                  without cause under the following condition:
                  <br />
                  <b>With Cause:</b> The Company may, immediately and without notice, terminate our
                  services with “cause”. The term “Cause” shall, as used in this document, mean:
                  <br />
                  a) The commission of a crime involving moral turpitude, theft, fraud or deceit.
                  <br />
                  b) Conduct that has an adverse effect on the Company reputation.
                  <br />
                  c) Substantial or continued unwillingness or inability to perform duties assigned
                  to the employee.
                  <br />
                  d) Gross negligence or deliberate misconduct.
                  <br />
                  e) Any material breach of terms and conditions specified in this letter.
                  <br />
                  f) Unauthorized absence from work for a period of three or more consecutive days
                  without due consent or notifying your superior office.
                  <br />
                  g) Providing any false information to the Company.
                  <br />
                  h) Consistent non-performance and inability to deliver on assigned tasks.
                  <br />
                  <b>Without Cause:</b> If the employment is terminated without cause, the employee
                  will be provided with a 30 days notice prior to such termination, or paid
                  severance pay in lieu thereof, equivalent to the compensation package for a period
                  of 30 days, calculated on the basic salary.
                  <br />
                  <b>Termination by the Employee:</b> If you wish to leave the services of the
                  company, a written notice of 90 days must be given to the Company. In case of
                  failure to give such written notice within the prescribed time, you are bound to
                  make good the loss suffered by the Company and any other charges/liabilities
                  Company incurs consequent to the failure to give required written notice. However,
                  due to exigencies of business, the Company may at its sole discretion reject the
                  salary in lieu of notice, and ask you to serve the entire or part of the notice
                  period. In the event of separation from services of the company, (separation can
                  also include termination on performance grounds), within 18 months of joining, the
                  Company has the right to recover the amount if paid to you in the form of
                  Relocation Reimbursement / Joining Bonus or any other expenses incurred which is
                  not part of the compensation structure.
                </Typography>
              </ListItem>

              <ListItem>
                <Typography variant="subtitle1">Other Engagements:</Typography>
                <Typography>
                  Your position is a whole-time employment with the company, and you shall devote
                  yourself exclusively to the business of the company. You will not take up any
                  other work for remuneration (part-time or otherwise) or work in advisory capacity
                  or be interested directly or indirectly (except as a shareholder or debenture
                  holder) in any other trade or business during the employment with the company
                  without permission in writing of the Managing Director of the company.
                </Typography>
              </ListItem>

              <ListItem>
                <Typography variant="subtitle1">Confidentiality & Non-Disclosure:</Typography>
                <Typography>
                  You hereby acknowledge that by the reason of your services with the company you
                  will have access to records, documents, drawings, forms, reports, studies,
                  memoranda, correspondence, manuals, plans, magnetic media and other information
                  sources (“Confidential Material”) and such Confidential Material constitutes the
                  property of the Company and/or its clients, enables the Company and/or its clients
                  to compete successfully in business and was acquires or created by the company
                  and/or its clients at substantial expenses.
                  <br />
                  <br />
                  In consideration of your services and the above disclosures, you agree that:
                  <br />
                  <br />
                  a) You will disclose to the Company all information, inventions, products,
                  systems, programs, documentation including improvements or modifications
                  (“Proprietary Material”), relating to the Company and its clients which you
                  acquired or developed during the terms of your services with the Company and that
                  such Proprietary Material is the sole property of the Company facilities, or with
                  the Company property or personnel. You will not disclose any such Proprietary
                  Material to any unauthorized person during or after the completion of services
                  with the Company.
                  <br />
                  b) You will not remove from the Company premises and/or the premises of its
                  clients any Confidential Material, expect in the performance of your duties. Upon
                  termination of your services or when called upon by the Company, you will
                  surrender all such Confidential Material together with any other the Company
                  property that have been provided to him/her by the Company and/or its clients.
                  <br />
                  c) You agree to comply with a supplementary agreement, when issued, between the
                  Company and a client regarding privacy and confidentiality. Such agreement will be
                  incorporated into this Agreement by reference, including improvements or
                  modification. “Proprietary Material” relating to the Company and its clients which
                  you acquired or developing during the term of your services with the Company and
                  its clients is the sole property of the Company or its clients regardless of
                  whether or not its acquisition occurs during work hours.
                </Typography>
              </ListItem>

              <ListItem>
                <Typography variant="subtitle1">Indemnity:</Typography>
                <Typography>
                  You shall keep the company indemnified for any damages, which the company or its
                  client may suffer due to any act/acts by you including breach of any terms of this
                  agreement.
                </Typography>
              </ListItem>

              <ListItem>
                <Typography variant="subtitle1">Code of Ethics and Business Conduct:</Typography>
                <Typography>
                  a) When you sign this letter of offer, you are agreeing the company’s Code of
                  Ethics and Business Conduct and you are agreeing to abide by it.
                  <br />
                  b) You will not accept gifts, entertainment, or other favors, from persons, or
                  bodies, which the Company has business dealings with, unless you have obtained the
                  previous written.
                  <br />
                  c) You will, upon termination of your employment with us, return all property
                  belonging to the client, including without limitation, all Proprietary
                  Information, documents, software, discs, diskettes, tapes, and any other form of
                  media, copies of any of the above, microcomputer systems, computer terminals,
                  modems, other hardware, telephones, credit cards, and/or company automobile.
                  <br />
                  d) You will treat your fellow workers with respect and dignity.
                </Typography>
              </ListItem>

              <ListItem>
                <Typography variant="subtitle1">Past Record:</Typography>
                <Typography>
                  If any declaration given or furnished by you to the company proves to be false or
                  if you are found to have willfully suppressed any material information, your
                  services are liable to be terminated immediately, without any dues.
                </Typography>
              </ListItem>

              <ListItem>
                <Typography variant="subtitle1">Governing Law:</Typography>
                <Typography>
                  This Agreement shall be governed by, and construed in accordance with, the laws of
                  the Republic of India.
                </Typography>
              </ListItem>

              <ListItem>
                <Typography variant="subtitle1">Waiver:</Typography>
                <Typography>
                  The failure of a party to insist upon strict adherence to any term of this
                  Agreement on any occasion or occasions shall not be considered a waiver thereof or
                  deprive that party of the right thereafter to insist upon strict adherence to that
                  term or any other term of this Agreement.
                </Typography>
              </ListItem>

              <ListItem>
                <Typography variant="subtitle1">Period of Employment:</Typography>
                <Typography>
                  The age of retirement shall be 58 years and on superannuation you shall be
                  entitled to such benefits as are available under the law and or the rules framed
                  by the company.
                </Typography>
              </ListItem>

              <ListItem>
                <Typography variant="subtitle1">Entire Agreement:</Typography>
                <Typography>
                  This Agreement contains the entire agreement of the parties and shall supersede
                  any prior verbal or written agreement or understanding between the Employee and
                  the Company.
                  <br />
                  <br />
                  The Employee acknowledges that in choosing to accept the Company&apos;s offer of
                  employment (and/or to continue such employment), he has not relied on any
                  warranties, representations, or promises by the Company, its employees, or any
                  other parties except as specifically set forth herein.
                </Typography>
              </ListItem>
            </List>
          </StyledList>

          <Stack paddingX={'20px'} alignItems="flex-start">
            <Typography sx={{ fontFamily: 'Verdana, sans-serif', lineHeight: 1.2 }}>
              I have read, understood and agree to the terms and conditions as set forth in this
              offer letter:
            </Typography>
            <Stack
              width={'100%'}
              height={'950px'}
              alignSelf={'end'}
              alignItems={'end'}
              justifyContent={'start'}
              sx={{
                backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.7), rgba(255, 255, 255, 0.7)), url(/assets/background/logoSG.png)`,
                backgroundSize: '400px',
                backgroundPosition: 'center bottom',
                backgroundRepeat: 'no-repeat',
              }}
            >
              <br />
              <br />
              <br />
              ------------------------------
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </>
  );
};

export default Terms;
